import { NotificationChannelType } from '@/lib/enums/NotificationChannelType'

export const notificationChannelLabelOverrides: Record<string, string> = {
  [NotificationChannelType.Phone.Value]: 'Phone Call',
}

export function getNotificationChannelLabel(channel: string, fallback = channel): string {
  return notificationChannelLabelOverrides[channel] ?? fallback
}
